import { GET_LOW_STOCK_SUPPLIES_REQUEST, GET_LOW_STOCK_SUPPLIES_SUCCESS, GET_LOW_STOCK_SUPPLIES_ERROR } from "../actions/lowStockSupplies"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const getLowStockSupplies = (state = initialState, action) => {
    switch (action.type) {
        case GET_LOW_STOCK_SUPPLIES_REQUEST:
            return {
                ...state,
                loading: true
            }

        case GET_LOW_STOCK_SUPPLIES_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case GET_LOW_STOCK_SUPPLIES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        default:
            return state;
    }
}

export default getLowStockSupplies
